import { Typography, Grid } from "@material-ui/core";
import SanitizedGrid from "components/SanitizedGrid";
import {
  CreateProps,
  SimpleForm,
  ReferenceInput,
  AutocompleteInput,
  required,
  TextInput,
  SelectInput,
  FormDataConsumer,
  ArrayInput,
  SimpleFormIterator,
} from "react-admin";
import { GetParam, SchoolIdSelected } from "utils/tools";
import CustomCreateToolbar from "../../components/CustomCreateToolbar";
import CustomDatePickerInput from "../../components/CustomDatePickerInput";
import moment from "moment/moment";
import React from "react";
import SelectedSchoolInput from "components/SelectedSchoolInput";
import CustomNumberInput from "../../components/CustomNumberInput";
import { subcontractorsAdhocCategoryList } from "./const";
import CreateWrapper from "../../components/CreateWrapper";
import Alert from "@material-ui/lab/Alert";

const SubcontractorAdhocFeeCreate = (props: CreateProps) => {
  const param = GetParam();
  const schoolIdSelected = SchoolIdSelected();

  const breadcrumb = [
    {
      title: "Subcontractors",
      link: `/subcontractors/${param.get("subcontractorId")}/show`,
    },
    {
      title: "Financial",
      link: `/subcontractors/${param.get("subcontractorId")}/show/2`,
    },
    {
      title: `Create Subcontractor Adhoc Fee`,
      link: "",
    },
  ];

  const transform = async (data: any) => {
    if (data.subcontractorAdhocFees && data.subcontractorAdhocFees.length > 0) {
      data.subcontractorAdhocFees = data.subcontractorAdhocFees.map(
        (item: any) => {
          if (item.amount) {
            item.amount = Number(Math.round(Number(item.amount) * 100.0));
          }

          if (item.typePeriod !== "date") {
            item.date = null;
          }

          if (item.category) {
            item.category = item.category;
          }

          if (data.schoolId) {
            item.schoolId = data.schoolId;
          }
          if (data.subcontractorId) {
            item.subcontractorId = data.subcontractorId;
          }
          return item;
        }
      );
    }

    delete data.category;
    delete data.schoolId;
    delete data.subcontractorId;

    return data;
  };

  return (
    <>
      <CreateWrapper
        breadcrumb={breadcrumb}
        headerTitle="Create Subcontractor Adhoc Fee"
        transform={transform}
        {...props}
      >
        <SimpleForm
          toolbar={
            <CustomCreateToolbar
              directAction={`/subcontractors/${param.get(
                "subcontractorId"
              )}/show/2`}
            />
          }
        >
          <SanitizedGrid container spacing={2}>
            <Grid item xs={12}>
              <Typography variant="h6">General Info</Typography>
            </Grid>

            <Grid item xs={4}>
              <ReferenceInput
                label="Subcontractor"
                source="subcontractorId"
                reference="subcontractors"
                validate={required()}
                disabled
              >
                <AutocompleteInput optionText="name" />
              </ReferenceInput>
            </Grid>
            <Grid item xs={8}></Grid>

            <Grid item xs={4}>
              <SelectedSchoolInput
                schoolIdSelected={schoolIdSelected}
                disabled
              />
            </Grid>
            <Grid item xs={8}></Grid>

            <Grid item xs={12}>
              <Typography variant="h6">Adhoc Fee Detail</Typography>
            </Grid>

            <Grid item xs={4}>
              <Alert severity="info">
                By default, the amount entered is considered a positive value.
                <br/>
                If you want to create a deduction (negative value), please prefix
                the amount with a minus sign (e.g., <strong>-100</strong>).
              </Alert>
            </Grid>
            <Grid item xs={8}></Grid>

            <Grid item xs={4}>
              <ArrayInput source="subcontractorAdhocFees">
                <SimpleFormIterator>
                  <SelectInput
                    source="typePeriod"
                    label="Type Period"
                    choices={[
                      { id: "date", name: "By Date" },
                      { id: "custom", name: "Custom Period" },
                    ]}
                    validate={required()}
                  />

                  <FormDataConsumer>
                    {({ scopedFormData, getSource }) => {
                      return (
                        <>
                          {scopedFormData?.typePeriod === "date" && (
                            <CustomDatePickerInput
                              name={getSource("date")}
                              label="Date"
                              max={moment().format("Y-MM-DD")}
                            />
                          )}

                          {scopedFormData?.typePeriod === "custom" && (
                            <TextInput
                              source={getSource("period")}
                              label="Custom Period (Free text)"
                              validate={required()}
                            />
                          )}
                        </>
                      );
                    }}
                  </FormDataConsumer>

                  <TextInput
                    source="routeName"
                    label="Route Name (Free text)"
                    validate={required()}
                  />

                  <SelectInput
                    source="category"
                    label="Category"
                    choices={subcontractorsAdhocCategoryList}
                    validate={required()}
                  />

                  <CustomNumberInput
                    label="Amount ($)"
                    source="amount"
                    isRequired
                  />

                  <TextInput
                    multiline={true}
                    label="Remarks"
                    source="remarks"
                    inputProps={{ maxLength: 90 }}
                    validate={required()}
                  />
                </SimpleFormIterator>
              </ArrayInput>
              <Grid item xs={8}></Grid>
            </Grid>
          </SanitizedGrid>
        </SimpleForm>
      </CreateWrapper>
    </>
  );
};

export default SubcontractorAdhocFeeCreate;
